import {
  setUser,
  captureException,
  init,
  addBreadcrumb,
  captureMessage,
  browserTracingIntegration,
  replayIntegration,
} from "@sentry/react";

class CrashlyticService {
  identify = (id) => setUser({ id: id.toString() });

  captureException = (exception) => captureException(exception);

  captureMessage = (message) => captureMessage(message);

  init = () =>
    init({
      dsn: "https://ba847f482be20d510091d71caec63e92@o1294447.ingest.us.sentry.io/4508092535799808",
      integrations: [browserTracingIntegration(), replayIntegration()],
      environment: process.env.REACT_APP_ENV,
      enabled: process.env.REACT_APP_ENV !== "development",
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions

      // Session Replay
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      normalizeDepth: 10,
    });

  addBreadcrumb = ({
    category,
    message,
    level = "info",
    timestamp = Date.now(),
  }) => addBreadcrumb({ category, message, level, timestamp });
}

export default new CrashlyticService();
